import { Address } from './address';
import { prop, required, propObject, disable } from '@rxweb/reactive-form-validators';
import { PersonType } from '../enums/person-type.enum';

export class ResponsibleAddress {
  constructor(persona?: PersonType) {
    this.address = new Address();
    this.responsibleAddressPersona = persona;
  }

  @prop()
  responsibleAddressPersona = '';

  @required()
  @propObject(Address)
  address: Address;

  @required()
  @prop({ ignore: (entity) => entity.responsibleAddressPersona !== PersonType.Juridica })
  partType: string;
}
